export default __webpack_public_path__ + "static/media/4C.0fbcba4d.webp";